import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareWarning } from 'lucide-react';

const ComplaintsPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-red-50/30 to-slate-50 pt-32 pb-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-rose-500 to-red-500 rounded-2xl mb-6 shadow-xl shadow-rose-500/30">
            <MessageSquareWarning className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-4 px-1">Complaints Policy</h1>
          <div className="h-1 w-20 bg-gradient-to-r from-rose-500 to-red-500 mx-auto rounded-full" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl border border-slate-200 p-8 md:p-12"
        >
          <div className="space-y-8 text-slate-700 leading-relaxed [&_p]:text-justify [&_p]:hyphens-auto [&_li]:text-justify">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">IBAN Complaints Policy</h2>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">Introduction</h3>
              <p className="mb-4">
                a) Your service provider is Payswix, UAB (hereinafter - Payswix), legal entity code
                304604766, registered legal entity address at Lvivo str. 25-104, Vilnius, the Republic of
                Lithuania, email address: support@payswix.com, website:
                https://www.payswix.com/, data about the company is collected and stored at the Register of
                Legal Entities of the Republic of Lithuania; Electronic Money Institution license No. 21,
                issued on 8 December 2017; issuing and supervisory body is the Bank of Lithuania
                (www.lb.lt).
              </p>
              <p className="mb-4">
                b) TRANSACTWORLD LIMITED (hereinafter - Agent) company code HE303056, registered address
                at 3 Thivon Street, Anna Court 8-9, Office 202, CY-1056 Nicosia, Cyprus is an authorized
                agent of Payswix and helps Clients to reach services and create legal relationship between
                Clients and Payswix. Agent acts as registered intermediary to Payswix.
              </p>
              <p className="font-semibold">THEREFORE, complaints policy is presented below:</p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">1. General provisions</h3>
              <p className="mb-3">
                1.1. As a licensed Electronic Money Institution regulated by the Bank of Lithuania, payswix
                is committed to providing its Customers the best service possible with full transparency.
                Payswix understands how important it is to protect its customers legal rights and legitimate
                interests, thus, the Company has implemented regulations as specified in Payswix Complaints
                Policy (hereinafter - Policy) for its customers to be followed in order to properly express
                and submit their complaints.
              </p>
              <p className="mb-3">
                1.2. The Policy has been prepared in accordance with applicable legal acts and regulations:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>1.2.1. Payment Law of the Republic of Lithuania;</li>
                <li>1.2.2. Bank of Lithuania Law of the Republic of Lithuania;</li>
                <li>1.2.3. Law on the Protection of Consumer Rights of the Republic of Lithuania;</li>
                <li>
                  1.2.4. The Rules for the out-of-court settlement procedure for disputes between consumers
                  and financial market participants at the Bank of Lithuania, approved by the Resolution of
                  the Board of the Bank on Lithuania on 2024-02-28, No. 03-28;
                </li>
                <li>
                  1.2.5. The Rules for the examination of requests and complaints and for the service of
                  persons at the Bank of Lithuania, approved by the Resolution of the Board of the Bank on
                  Lithuania on 2014-05-08, No. 03-76.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">2. Definitions &amp; abbreviations</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  2.1. Customer - a natural person or legal entity holding an account with the Company
                  and/or using any of the Companys provided services. Within the scope of this Policy, the
                  customer also means the Companys former Customers and successors in the title of a Company
                  Customers.
                </li>
                <li>
                  2.2. Applicant - a natural person or legal entity who is interested in the Companys
                  provided services and seeks to become the Companys customer.
                </li>
                <li>
                  2.3. Company or payswix - shall mean Payswix, UAB, company code: 304604766, legal
                  registration address: Lvivo St. 25-104, LT-09320 Vilnius, Lithuania.
                </li>
                <li>
                  2.4. Agent - Transactworld Ltd, legal entity code HE303056, registered legal entity
                  address at 3 Thivon Street, Anna Court 8-9, Office 202, CY-1056 Nicosia, Cyprus, email
                  address: support@transactworld.com, website https://www.transactworld.com/.
                  TRANSACTWORLD LIMITED is an authorized agent of payswix and helps Clients to reach
                  services and create legal relationship between Clients and payswix. Agent acts as
                  registered intermediary to payswix.
                </li>
                <li>
                  2.5. Complaint - a written expression by e-mail or post of dissatisfaction of the Customer
                  addressed to Payswix, UAB claiming that the rights and/or legitimate interests of the
                  Customer have been violated in relation to the services provided by the Company and/or
                  agreements concluded with the Company and asking for satisfaction of the claims.
                </li>
                <li>
                  2.6. Query - question raised by the Companys Customer and/or Applicant about the Companys
                  services or expressed dissatisfaction of Companys services and/or internal procedures not
                  related to the Companys breach of applicable legal acts or service agreements with the
                  Customer.
                </li>
                <li>2.7. Complainant - the person making the Complaint.</li>
                <li>
                  2.8. Consumer - a natural person who seeks to open or opens an account with the Company
                  for purposes other than its business or professional activity, i.e. who use a particular
                  financial service to meet its personal, family or household needs (consumption purposes).
                </li>
                <li>
                  2.9. Third party - a natural person or legal entity, including statutory authorities that
                  does not have a contractual relationship with the Company.
                </li>
                <li>
                  2.10. Complaint specialist - an Operations department employee assigned to handle the
                  Complaint.
                </li>
                <li>2.11. Feedback notice - a written confirmation of the outcome of the Complaint.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                3. Complaints submitting instructions for Customers
              </h3>
              <p className="mb-3">
                3.1. All Payswix Customers can submit a Complaint by using one of the channels below if it
                is deemed that their rights and/or legitimate interests in regard to usage of the Companys
                services have been breached:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-3">
                <li>3.1.1. via email at support@transactworld.com;</li>
                <li>
                  3.1.2. via post to Agent office at Agents correspondence address as provided on the Agents
                  website;
                </li>
                <li>
                  3.1.3. via phone, contacting Customer Support Centre as provided on the Agents website.
                </li>
              </ul>
              <p className="mb-3">
                3.2. After receiving Customers Complaint Agent is obliged to forward the Complaint to the
                Company as soon as possible but in any case no later than within 1 (one) business day. Agent
                notifies a Complainant immediately about forwarding the Complaint to the Company.
              </p>
              <p className="mb-3">
                3.3. It shall be noted that in case of Queries from either the Companys Customers, Applicants
                or other Third parties - the Policy shall not apply and Queries should be submitted to the
                Agent by using general contact information as indicated on the Agents website.
              </p>
              <p className="mb-3">
                3.4. The Company registers and deals only with Complaints which include at least the
                following data:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-3">
                <li>
                  3.4.1 Full legal name and surname of the Complainant. In case the Complainant is a legal
                  entity, the companys name and the legal name and surname of the legal entity representative
                  shall be specified;
                </li>
                <li>
                  3.4.2. Account number and/or other account/Complainant information from which the Company
                  could identify that the account belongs/belonged to the Complainant;
                </li>
                <li>
                  3.4.3. Contact details of the Complainant which shall be used by the Agent to send a
                  Feedback notice. If no preferred contact information is provided in the Complaint, the
                  Agent shall send the Feedback notice by using the same contact information that Complaint
                  was submitted from;
                </li>
                <li>
                  3.4.4. Description of legal rights and/or legitimate interests of the Complainant that
                  were potentially breached by the Company as well as claims that Complainant seeks to be
                  satisfied by submitting the Complaint.
                </li>
                <li>
                  3.4.5. If available, evidence to support the Complaint (e.g., correspondence, documents,
                  account statements, etc.).
                </li>
              </ul>
              <p className="mb-3">
                3.5. Once the Complaint is received by the Company, the Complaint is registered into Companys
                internal Complaint register and a Complaint specialist is assigned to handle the Complaint.
              </p>
              <p>
                3.6. All Companys Complaints are handled within 24 hours from the receipt of the Complaint
                from the Agent. After Complaint is handled Agent sends a Feedback notice to the Complainant.
                However, if the Complaint is more complex and cannot be resolved immediately, the Feedback
                notice will specify the additional time, required to properly handle the Complaint and/or
                additional information and documents to be provided by the Complainant, required for further
                investigation. In such cases, the Complaint shall be handled within 15 business days from the
                day the Complaint was received by the Company or, if applicable, the receipt of all requested
                data from the Complainant. The aggregate timelines of Complaint handling shall not exceed 35
                business days.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                4. Complaints resolution through authorities
              </h3>
              <p className="mb-3">
                4.1. All Companys customers if not satisfied with the decision made by the Company or did
                not receive any response from the Agent within 15 business days from the day the Complaint
                was received by the Company, shall have the right to use other legitimate remedies and to
                submit a complaint to the Bank of Lithuania:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-3">
                <li>By filling out the online application form;</li>
                <li>
                  By completing the application form (which can be found here) and e-mailing it to
                  info@lb.lt;
                </li>
                <li>
                  By filling out a free-form application or completing the application form as indicated
                  above and sending it by post or physically presenting it to the Bank of Lithuania at
                  Totoriu str. 4, Vilnius, Lithuania.
                </li>
              </ul>
              <p className="mb-3">
                4.2. Regardless of which method is selected, the Complaint and its annexes must be signed
                and submitted in Lithuanian or English.
              </p>
              <p className="mb-3">
                4.3. Companys customers which are Consumers, if not satisfied with the decision made by the
                Company or did not receive any response from the Agent within 15 business days from the day
                the Complaint was received by the Company - have a right to use out of court settlement of
                disputes and within 1 year from the submission of the Complaint to the Agent, bring the
                complaint to the Bank of Lithuania. The complaint can be submitted to the Bank of Lithuania:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-3">
                <li>Via Electronic consumer dispute resolution system here;</li>
                <li>
                  By completing the Consumer Application Form (the form can be found here) and sending it to
                  the Law and Licensing Department of the Bank of Lithuania by e-mail
                  prieziura@lb.lt or by post to Totoriu str. 4, 01121 Vilnius.
                </li>
              </ul>
              <p className="mb-3">
                4.4. An application submitted via the electronic consumer dispute resolution system is
                considered signed by the Consumer. An application submitted by mail must be signed by the
                Complainant (or an authorised representative). An application submitted by electronic means
                (e.g. by email) must be signed by the Complainant (or an authorised representative) with a
                qualified electronic signature.
              </p>
              <p>
                4.5. It shall be emphasized that Consumers have the right to choose whether to apply to the
                Bank of Lithuania or directly to court. The court ruling is binding, while the decision of
                the Bank of Lithuania is of a recommendatory nature, non-binding to both the Consumer and the
                Company and cannot be appealed. Nevertheless, even when the Bank of Lithuania has taken a
                decision, the parties to a dispute (the Consumer and the Company) retain the right to apply
                to the court. Hence, if the dispute is not settled amicably or through other means of
                out-of-court settlement of disputes, the dispute shall be resolved in court according to the
                headquarters of the Company.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">5. Final provisions</h3>
              <p className="mb-3">
                5.1. Should any assistance be required to properly submit the Compliant, the Agent remains
                available for all its Customers via phone or email. The exact contact details can be found on
                Agents website.
              </p>
              <p className="text-sm text-slate-500">
                Copyright (c) Transactworld 2025. All Rights Reserved.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ComplaintsPolicy;
